// Phone-only bottom tab bar. Replaces the sidebar on viewports <=640px.

import { Home, Zap, LayoutGrid, Package, HelpCircle } from 'lucide-react';
import type { ViewName } from '../../lib/store';

interface Tab {
  view: ViewName;
  label: string;
  icon: typeof Home;
}

const TABS: Tab[] = [
  { view: 'home',    label: 'Home',    icon: Home },
  { view: 'reorder', label: 'Reorder', icon: Zap },
  { view: 'designs', label: 'Designs', icon: LayoutGrid },
  { view: 'orders',  label: 'Orders',  icon: Package },
  { view: 'help',    label: 'Help',    icon: HelpCircle },
];

interface MobileTabBarProps {
  view: ViewName;
  onNavigate: (next: ViewName) => void;
}

export function MobileTabBar({ view, onNavigate }: MobileTabBarProps) {
  return (
    <nav className="bottom-tabs" aria-label="Studio navigation (mobile)">
      {TABS.map((t) => {
        const Icon = t.icon;
        const active = t.view === view;
        return (
          <button
            key={t.view}
            type="button"
            className={`bottom-tabs__btn${active ? ' is-active' : ''}`}
            onClick={() => onNavigate(t.view)}
            aria-current={active ? 'page' : undefined}
          >
            <Icon className="ico" aria-hidden="true" strokeWidth={1.6} />
            <span>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
